// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input__Input__1VROp","label":"Input__label__2torh","InputElement":"Input__InputElement__3TB0k","Invalid":"Input__Invalid__38X2d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.css
// module id = 256
// module chunks = 0